// extracted by mini-css-extract-plugin
module.exports = {"badge":"Badge_badge__nAKK_","badge__textContent":"Badge_badge__textContent__YJLt6","badge--proOnly":"Badge_badge--proOnly__aFFIY","badge--sale":"Badge_badge--sale__hzMG2"};